import React from "react";
import { useHandler } from "@whalecloud/page-builder-core/hooks/useHandler";
import ConnectedSlate from "@whalecloud/page-builder-core/components/Slate";
import { ElementRoot } from "@whalecloud/page-builder-core/components/ElementRoot";

export const className = "webiny-pb-base-page-element-style webiny-pb-page-element-text";

const Text = props => {
    const { element } = props;
    const { componentSettings, className: elClassName = '' } = element?.data;

    const onChange = useHandler(props, ({ element, updateElement }) => value => {
      const newElement = element;
      newElement.data.text = value;
      updateElement({ element: newElement });
    });

    return (
        <ElementRoot element={element} className={`${className} ${elClassName}`} style={{ ...componentSettings }}>
            <ConnectedSlate value={element.data.text} onChange={onChange} />
        </ElementRoot>
    );
};

export default Text
